module.exports = __webpack_public_path__ + "static/media/1A08C983-7693-4BE2-90CD-E55FB0568DAC.00ffdfff.JPG";